import ufeApi from 'services/api/ufeApi';

function saveCustomerPreferences(data) {
    return ufeApi
        .makeRequest('/gway/v1/preferences/account', {
            method: 'PUT',
            body: JSON.stringify(data)
        })
        .then(response => {
            if (response.responseStatus === 200) {
                return response;
            }

            throw response;
        });
}

export default saveCustomerPreferences;
